import React, { forwardRef } from "react";
import API from "../API/newIndex";

export const uploadTextEditorImage = async (file) => {
  console.log(file, 'file');
  const result = await API({
    url: "/admin/fileupload/upload",
    method: "POST",
    data: file,
  });
console.log(result, 'result');
  if (result?.data?.data?.length > 0) {
    return result.data.data[0];
  }

  throw new Error("Image upload failed");
};

export const isAscendingOrder = (order) => {
  if (!order) return false;
  if (typeof order === 'string') {
    const upper = order.trim().toUpperCase();
    return upper === 'ASC' || upper === 'A-Z' || upper === '1' || upper === 'TRUE';
  }
  if (typeof order === 'object') {
    if (order.orderByValue !== undefined) {
      const upper = String(order.orderByValue).trim().toUpperCase();
      return upper === 'ASC' || upper === 'A-Z' || upper === '1' || upper === 'TRUE';
    }
    if (order.order_by !== undefined) {
      const upper = String(order.order_by).trim().toUpperCase();
      return upper === 'ASC' || upper === 'A-Z' || upper === '1' || upper === 'TRUE';
    }
    if (order.isDecending !== undefined) {
      return order.isDecending === false || order.isDecending === 'false';
    }
    if (order.isDescending !== undefined) {
      return order.isDescending === false || order.isDescending === 'false';
    }
    if (order.isAscending !== undefined) {
      return order.isAscending === true || order.isAscending === 'true';
    }
  }
  return false;
};

/**
 * TextareaComponent — Shopify/shadcn-style reusable textarea for the entire admin panel.
 */
export const TextareaComponent = forwardRef(({
  id,
  name,
  value,
  onChange,
  placeholder,
  required = false,
  className = '',
  containerClassName = '',
  label,
  labelAction,
  tabIndex,
  onKeyDown,
  error = '',
  helpText = '',
  rows = 3,
  cols,
  maxLength,
  showCharCount = false,
  resize = 'vertical',
  size = 'md',
  disabled = false,
  readOnly = false,
  ...props
}, ref) => {
  const hasValue = value !== undefined && value !== null && value.toString().trim() !== '';

  // ── Size Styles ───────────────────────────────────────────────────────
  const sizeClasses = {
    sm: 'px-2.5 py-1.5 text-xs',
    md: 'px-3 py-2 text-sm',
  };

  const appliedSize = sizeClasses[size] || sizeClasses.md;

  // ── Resize Styles ─────────────────────────────────────────────────────
  let resizeClass = 'resize-y';
  if (resize === false || resize === 'none') {
    resizeClass = 'resize-none';
  } else if (resize === 'horizontal') {
    resizeClass = 'resize-x';
  } else if (resize === 'both' || resize === true) {
    resizeClass = 'resize';
  } else if (typeof resize === 'string' && resize.startsWith('resize-')) {
    resizeClass = resize;
  }

  // ── Textarea classes ──────────────────────────────────────────────────
  const textareaClasses = [
    'w-full border rounded-lg outline-none transition-all duration-150',
    'text-[var(--primary-text-color)] placeholder-gray-400',
    'bg-[var(--secondary-bg-color)]',
    'border-[var(--border-color)]',
    'hover:border-[var(--focus-border-color)]',
    'focus:border-[var(--focus-border-color)] focus:ring-0 focus:bg-[var(--secondary-bg-color)]',
    error ? 'border-[var(--color-danger,#ef4444)] focus:ring-0 focus:border-[var(--color-danger,#ef4444)]' : '',
    disabled ? 'opacity-60 cursor-not-allowed bg-[var(--focus-tab-color)]' : '',
    hasValue && !disabled ? 'bg-[var(--secondary-bg-color)]' : '',
    appliedSize,
    resizeClass,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const currentLength = value ? String(value).length : 0;

  return (
    <div className={`w-full flex flex-col gap-1 text-left ${containerClassName}`.trim()}>
      {(label || labelAction) && (
        <div className='flex items-center justify-between mb-0.5'>
          {label ? (
            <label
              htmlFor={id}
              className='text-[var(--primary-text-color)] font-medium text-[13px] tracking-tight flex items-center mb-0'
              style={{ marginBottom: 0 }}
            >
              {label}
              {required && <span className='text-[var(--color-danger,#ef4444)] ml-0.5'>*</span>}
            </label>
          ) : <div />}
          {labelAction && <div>{labelAction}</div>}
        </div>
      )}

      <div className='relative w-full flex flex-col'>
        <textarea
          ref={ref}
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          tabIndex={tabIndex}
          onKeyDown={onKeyDown}
          disabled={disabled}
          readOnly={readOnly}
          rows={rows}
          cols={cols}
          maxLength={maxLength}
          className={textareaClasses}
          {...props}
        />
      </div>

      {(error || helpText || showCharCount) && (
        <div className='flex items-center justify-between text-xs mt-0.5'>
          <div>
            {error ? (
              <p className='text-[var(--color-danger,#ef4444)] font-medium m-0'>{error}</p>
            ) : (
              helpText && <p className='text-[var(--table-text-color)] m-0'>{helpText}</p>
            )}
          </div>

          {showCharCount && (
            <span className='text-[var(--table-text-color)] ml-auto text-[11px]'>
              {currentLength}{maxLength ? ` / ${maxLength}` : ''}
            </span>
          )}
        </div>
      )}
    </div>
  );
});

